import React from 'react';
import NewsletterLanding from './components/NewsletterLanding';

function App() {
  return (
    <div className="App">
      <NewsletterLanding />
    </div>
  );
}

export default App;
